import { RouteFactory } from "@app/routePaths";
import { BlockTitle } from "@blocks/Blocks";
import AccordionV2 from "@components/Accordion/AccordionV2";
import EventsAwardsAccordionHeader from "@events-awards/components/EventsAwardsAccordionHeader";

/**
 * Component to render DTA awards page
 */
const DTAAwardsPage = (): React.ReactElement => {
  return (
    <div
      className="mb-5 font-public-sans leading-[1.4]"
      data-testid="dta-awards-page-component"
    >
      <BlockTitle
        text="Awards"
        rootClassName="py-3 text-4xl md:text-6xl lg:text-8xl font-medium mb-8"
      />

      <AccordionV2
        testId="start-ups-and-smes-accordion"
        className="rounded-tl-lg rounded-tr-lg border border-gray-175 bg-gray-150 py-4"
        headerChildren={
          <EventsAwardsAccordionHeader title="Start-ups and SMEs" />
        }
        arrowClassName="border-none h-auto w-auto -rotate-90 mr-6"
        isArrowRight
      >
        <div className="mt-4 border-t border-gray-175 px-6 py-4 pt-4">
          <p>
            This category celebrates the bold ideas and inventive spirit of
            start-ups and small to medium-sized enterprises (SMEs) that are
            using design and technology to solve real-world problems.
          </p>

          <p>
            Be it a breakthrough product, smart system, or new user experience,
            we recognise young and growing businesses that are driving
            meaningful impact through innovation, creativity, and agility.
          </p>

          <p>
            <strong>Eligibility</strong>
          </p>

          <ul className="list-outside list-disc pb-4 pl-8">
            <li>
              The award is open to all start-ups and SMEs globally, regardless
              of location.
            </li>

            <li>
              Eligibility is restricted to commercially launched projects.
            </li>

            <li>
              <p className="mb-0">
                Enterprise&apos;s annual group revenue should not exceed S$100
                million, or employ no more than 200 employees.
              </p>

              <p>
                Entities with a clear enterprise purpose are encouraged to
                participate, including business enterprises, social enterprises,
                charities and non-governmental organisations
              </p>
            </li>

            <li>
              The enterprise must comply with the terms and conditions outlined
              in the nomination declaration form.
            </li>
          </ul>

          <p>
            <a
              className="text-blue-175 hover:text-gray-750"
              href={`${RouteFactory.dtaNominatePage}#assessment`}
            >
              <u>
                <strong>Click here </strong>
              </u>
            </a>
            for the assessment criteria
          </p>
        </div>
      </AccordionV2>

      <AccordionV2
        testId="large-enterprise-accordion"
        className="rounded-bl-lg rounded-br-lg border border-t-0 border-gray-175 bg-gray-150 py-4"
        headerChildren={
          <EventsAwardsAccordionHeader title="Large Enterprises" />
        }
        arrowClassName="border-none h-auto w-auto -rotate-90 mr-6"
        isArrowRight
      >
        <div className="mt-4 border-t border-gray-175 px-6 py-4 pt-4">
          <p>
            This category recognises established companies that harness the
            power of design and technology to drive innovation at scale.
          </p>

          <p>
            From transforming legacy systems to launching impactful new
            solutions, we celebrate enterprises creating real-world change
            through bold thinking and purposeful design.
          </p>

          <p>
            <strong>Eligibility</strong>
          </p>

          <ul className="list-outside list-disc pb-4 pl-8">
            <li>
              The award is open to all large corporations globally, regardless
              of location.
            </li>

            <li>
              Eligibility is restricted to commercially launched projects.
            </li>

            <li>
              Enterprise&apos;s annual group revenue should exceed S$100
              million, or employ more than 200 employees.
            </li>

            <li>
              Entities with a clear enterprise purpose are encouraged to
              participate, including business enterprises, government agencies
              and government-linked companies
            </li>

            <li>
              The enterprise must comply with the terms and conditions outlined
              in the nomination declaration form.
            </li>
          </ul>

          <p>
            <a
              className="pr-1 text-blue-175 hover:text-gray-750"
              href={`${RouteFactory.dtaNominatePage}#assessment`}
            >
              <u>
                <strong>Click here</strong>
              </u>
            </a>
            for the assessment criteria
          </p>
        </div>
      </AccordionV2>
    </div>
  );
};
export default DTAAwardsPage;
